export default {
	tab: "Réservations",
	reserveConsultant: "Réserver un consultant",
	pending: "En attente",
	confirmed: "E-mail confirmé",
	awaitingConfirm: "E-mail non confirmé",
	receivedAt: "Reçue le",
	noEmailStatus: "Sans e-mail",
	viewDetails: "Voir les détails",
	phone: "Téléphone",
	email: "E-mail",
	approve: "Approuver",
	reject: "Refuser",
	expected: "Réservés",
	noExpected: "Personne n'a encore réservé.",
	noPending: "Aucune réservation en attente.",
	noRejected: "Aucune réservation refusée.",
	originPublic: "Publique",
	originInternal: "Interne",
	rejected: "Refusées",
	approveTitle: "Approuver la réservation",
	linkExisting: "Consultant existant",
	createNew: "Enregistrer un nouveau",
	consultant: "Consultant",
	attendanceType: "Type de service",
	groupByType: "Grouper par type de service",
	noType: "Sans type",
	attendanceTypeHint: "La réservation garantit un ticket de ce type ; les types complets sont indisponibles.",
	unlimited: "sans limite",
	full: "complet",
	selectType: "Sélectionnez le type de service.",
	firstName: "Prénom",
	lastName: "Nom",
	rejectTitle: "Refuser la réservation",
	rejectReason: "Motif (optionnel)",
	notes: "Remarque (optionnel)",
	reserve: "Réserver",
	reserved: "Consultant réservé !",
	approved: "Réservation approuvée !",
	rejectedDone: "Réservation refusée.",
	loadError: "Erreur lors du chargement des réservations.",
	saveError: "Impossible de terminer. Veuillez réessayer.",
	selectConsultant: "Sélectionnez le consultant.",
	firstNameRequired: "Saisissez le nom.",
	attended: "Servie",
	cancelReservation: "Annuler la réservation",
	editTitle: "Modifier la réservation",
	cancelTitle: "Annuler la réservation",
	cancelConfirm: 'Annuler la réservation de « {name} » ? La place sera libérée.',
	saved: "Réservation mise à jour !",
	cancelled: "Réservation annulée.",
	exportExcel: "Excel",
	printTitle: "Réservations du rituel",
	origin: "Origine",
	status: "Statut",
	awaitingAttendance: "En attente",
	contact: "Contact",
};
